import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import SsoLogin from "../pages/Authentication/SsoLogin"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Admin
import Forms from "../pages/Forms/Forms"
import NewForm from "../pages/Forms/NewForm"
import Form from "../pages/Forms/Form"

import QR from "../pages/Admin/QR"
import UnplannedTaskForms from "../pages/Admin/UnplannedTaskForms"
import TaskLoader from "../pages/Admin/TaskLoader"
import OneDashboard from "../pages/Admin/OneDashboard"


// Masters

import Assets from "../pages/Masters/Assets/Assets"
import NewAsset from "../pages/Masters/Assets/NewAsset"

import Activities from "../pages/Masters/Activities/Activities"
import NewActivity from "../pages/Masters/Activities/NewActivity"

import Properties from "../pages/Masters/Properties/Properties"
import NewProperty from "../pages/Masters/Properties/NewProperty"

import Blocks from "../pages/Masters/Blocks/Blocks"
import NewBlock from "../pages/Masters/Blocks/NewBlock"

import Buildings from "../pages/Masters/Buildings/Buildings"
import NewBuilding from "../pages/Masters/Buildings/NewBuilding"

import Floors from "../pages/Masters/Floors/Floors"
import NewFloor from "../pages/Masters/Floors/NewFloor"

import Rooms from "../pages/Masters/Rooms/Rooms"
import NewRoom from "../pages/Masters/Rooms/NewRoom"

import Groups from "../pages/Masters/Groups/Groups"
import NewGroup from "../pages/Masters/Groups/NewGroup"

import Employees from "../pages/Masters/Employees/Employees"
import NewEmployee from "../pages/Masters/Employees/NewEmployee"

import Admins from "../pages/Masters/Admins/Admins"
import NewAdmin from "../pages/Masters/Admins/NewAdmin"

import Assettypes from "../pages/Masters/Assettypes/Assettypes"
import NewAssettype from "../pages/Masters/Assettypes/NewAssettype"



// Reports

import DailyLogbook from "../pages/Reports/DailyLogbook"
import DailyLogsheet from "pages/Reports/DailyLogsheet"

import AlertLog from "../pages/Reports/Alerts/AlertLog"
import AlertSummary from "../pages/Reports/Alerts/AlertSummary"
import AlertTrend from "../pages/Reports/Alerts/AlertTrend"

import TasksNotDone from '../pages/Reports/Task/TasksNotDone'
import AllSiteTaskSummary from '../pages/Reports/Task/AllSiteTaskSummary'
import TaskSummary from '../pages/Reports/Task/TaskSummary'

import AssetStatusLog from '../pages/Reports/AssetStatusLog'
import RemarksLog from '../pages/Reports/RemarksLog'






// Dashboard
import Dashboard from "../pages/Dashboard/index"
import PpmDashboard from "../pages/Dashboard/PpmDashboard"


// import Task_Summary from "../pages/Ppm/task_Summary"
// import Cost_Report from "pages/Ppm/Cost_Report"
// import Logsheet_Report from "pages/Ppm/Logsheet_Report"
// import Next_Week from "pages/Ppm/next_week"
// import Current_week from "pages/Ppm/Current_Week"
// import Activity_Wise_Logsheet from "pages/Ppm/Activity_Wise_Logsheet"
// import Asset_Wise from "pages/Ppm/Asset_Wise"
// import Workorder_Listing from "pages/Ppm/Workorder_Listing"
// import Rescheudule from "pages/Ppm/Rescheudule"
// import Aprovel_Log from "pages/Ppm/ppm-aprovel-log"




// import ServiceType from "pages/Reports/ServiceType/ServiceType"
// import ServiceType_Add from "pages/Reports/ServiceType/ServiceType_Add"
// import DailyPpm from "pages/Reports/DailyLogbook/Ppm"
// import Archive_Logbook from "pages/Reports/Archive/logbook"
// import Archive_Logsheet from "pages/Reports/Archive/logsheet"
// import ActivityWiseLogsheet from "pages/Reports/DailyLogsheet/ActivityWiseLogsheet"
// import Summary from "pages/Reports/Verification/summary"
// import AssetStatusLogReport from "pages/Reports/Asset_status_logreport"
// import MobileUserLog from "pages/Reports/MobileUserLog"
// import RemarkLog from "pages/Reports/RemarkLog"
// import UnplannedTaskLog from "pages/Reports/UnplannedTaskLog"
// // import DailyLogSheetReport from "pages/Reports/DailyLogSheetReport"
// import EquipmentHistoryCard from "pages/Reports/EquipmentHistoryCard"
// import TaskSummaryReport from "pages/Reports/TaskSummaryReport"




// Masters - PPM

import Vendors from "../pages/Masters/Vendors/Vendors"
import NewVendor from "../pages/Masters/Vendors/NewVendor"

import Contracts from "../pages/Masters/Contracts/Contracts"
import NewContract from "../pages/Masters/Contracts/NewContract"

import Ppmactivities from "../pages/Masters/Ppmactivities/Ppmactivities"
import NewPpmactivity from "../pages/Masters/Ppmactivities/NewPpmactivity"


import PpmCalendar from "../pages/Ppm/PpmCalendar"

import PpmLogsheet from "../pages/Masters/Ppmactivities/PpmLogsheet"



const userRoutes = [

    // Dashboards

    { path: "/dashboard", component: Dashboard },
    { path: "/ppmdashboard", component: PpmDashboard },


    // //profile
    { path: "/profile", component: UserProfile },


    // Masters

    { path: "/properties/index", component: Properties },
    { path: "/properties/new", component: NewProperty },
    { path: "/properties/edit/:id", component: NewProperty },

    { path: "/blocks/index", component: Blocks },
    { path: "/blocks/new", component: NewBlock },
    { path: "/blocks/edit/:id", component: NewBlock },

    { path: "/buildings/index", component: Buildings },
    { path: "/buildings/new", component: NewBuilding },
    { path: "/buildings/edit/:id", component: NewBuilding },

    { path: "/floors/index", component: Floors },
    { path: "/floors/new", component: NewFloor },
    { path: "/floors/edit/:id", component: NewFloor },

    { path: "/rooms/index", component: Rooms },
    { path: "/rooms/new", component: NewRoom },
    { path: "/rooms/edit/:id", component: NewRoom },

    { path: "/groups/index", component: Groups },
    { path: "/groups/new", component: NewGroup },
    { path: "/groups/edit/:id", component: NewGroup },

    { path: "/employees/index", component: Employees },
    { path: "/employees/new", component: NewEmployee },
    { path: "/employees/edit/:id", component: NewEmployee },

    { path: "/admins/index", component: Admins },
    { path: "/admins/new", component: NewAdmin },
    { path: "/admins/edit/:id", component: NewAdmin },

    { path: "/forms/index", component: Forms },
    { path: "/forms/new", component: NewForm },
    { path: "/form", component: Form },
    { path: "/forms/edit/:id", component: NewForm },

    { path: "/assettypes/index", component: Assettypes },
    { path: "/assettypes/new", component: NewAssettype },
    { path: "/assettypes/edit/:id", component: NewAssettype },

    { path: "/assets/index", component: Assets },
    { path: "/assets/new", component: NewAsset },
    { path: "/assets/edit/:id", component: NewAsset },

    { path: "/activities/index", component: Activities },
    { path: "/activities/new", component: NewActivity },
    { path: "/activities/edit/:id", component: NewActivity },


    // Admin

    { path: "/qr", component: QR },
    { path: "/unplanned-task-forms", component: UnplannedTaskForms },
    { path: "/taskloader", component: TaskLoader },
    { path: "/oneDashboard", component: OneDashboard },




    // Reports

    { path: "/reports/logbook/daily", component: DailyLogbook },
    { path: "/reports/logsheet/daily", component: DailyLogsheet },

    { path: "/reports/alerts/log", component: AlertLog },
    { path: "/reports/alerts/summary", component: AlertSummary },
    { path: "/reports/alerts/trend", component: AlertTrend },

    { path: "/reports/task/tasks-not-done", component: TasksNotDone },
    { path: "/reports/task/all-sites-task-summary", component: AllSiteTaskSummary },
    { path: "/reports/task/task-summary", component: TaskSummary },

    { path: "/reports/asset-status-log", component: AssetStatusLog },
    { path: "/reports/remarks-log", component: RemarksLog },
    { path: "/ppm/logsheet", component: PpmLogsheet },











    // Archived / To Delete

    // { path: "/reports/archive/logbook", component: Archive_Logbook },
    // { path: "/reports/archive/logsheet", component: Archive_Logsheet },
    // { path: "/reports/logsheet/activity-wise", component: ActivityWiseLogsheet },
    // { path: "/reports/asset-status-log-report", component: AssetStatusLogReport },
    // { path: "/reports/mobile-user-log", component: MobileUserLog },
    // { path: "/reports/remark-log", component: RemarkLog },
    // { path: "/reports/unplanned-task-log", component: UnplannedTaskLog },
    // { path: "/reports/equipment-history-card", component: EquipmentHistoryCard },
    // { path: "/reports/archive/task_summary", component: TaskSummaryReport },

    // { path: "/verification/summary", component: Summary },




    // Masters - PPM

    { path: "/vendors/index", component: Vendors },
    { path: "/vendors/new", component: NewVendor },
    { path: "/vendors/edit/:id", component: NewVendor },

    { path: "/contracts/index", component: Contracts },
    { path: "/contracts/new", component: NewContract },
    { path: "/contracts/edit/:id", component: NewContract },

    { path: "/ppmactivities/index", component: Ppmactivities },
    { path: "/ppmactivities/new", component: NewPpmactivity },
    { path: "/ppmactivities/edit/:id", component: NewPpmactivity },


    // PPM
    { path: "/ppm/calendar", component: PpmCalendar },





    // import TasksNotDone from '../pages/Reports/Task/TasksNotDone'
    // import AllSiteTaskSummary from '../pages/Reports/Task/AllSiteTaskSummary'
    // import AllSiteTaskSummary from '../pages/Reports/Task/AllSiteTaskSummary'






    //Service Type adding
    // { path: "/service-type", component: ServiceType },
    // { path: "/service-type/new", component: ServiceType_Add },
    // { path: "/service-type/edit/:id", component: ServiceType_Add },





    // PPM
    // { path: "/ppm-task-summary", component: Task_Summary },
    // { path: "/cost-report", component: Cost_Report },
    // { path: "/logsheet", component: Logsheet_Report },
    // { path: "/next-week", component: Next_Week },
    // { path: "/current-week", component: Current_week },
    // { path: "/activity-wise", component: Activity_Wise_Logsheet },
    // { path: "/asset-wise", component: Asset_Wise },
    // { path: "/work-order-listing", component: Workorder_Listing },
    // { path: "/rescheudule", component: Rescheudule },
    // { path: "/aprovel-log", component: Aprovel_Log },


    // this route should be at the end of all other routes
    { path: "/", exact: true, component: () => < Redirect to = "/dashboard" / > },
]

const authRoutes = [
    { path: "/logout", component: Logout },
    { path: "/login", component: Login },
    { path: "/ssologin/:token/:username/:role_id?/:sites?", component: SsoLogin },
    { path: "/forgot-password", component: ForgetPwd },
    { path: "/register", component: Register },
]

export { userRoutes, authRoutes }